import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["intent", "className", "innerRef"];
import * as React from 'react';
import clsx from 'clsx';
import Svg from '../../Svg';
import { Base } from '../../Base';
var styles = {
  "root": "StatusIcon-root_194w9",
  "icon": "StatusIcon-icon_2SEqI"
};
var intentToIcon = {
  info: 'infoWire',
  success: 'successWire',
  warning: 'warningWire',
  danger: 'dangerWire',
  progress: 'infoWire',
  unknown: 'questionWire'
};
function StatusIcon(_ref) {
  var _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'info' : _ref$intent,
    className = _ref.className,
    innerRef = _ref.innerRef,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Base, _extends({
    tagName: "span",
    className: clsx(styles.root, className)
  }, extraProps), /*#__PURE__*/React.createElement(Svg, {
    name: intentToIcon[intent],
    theme: intent,
    className: styles.icon
  }));
}
export default StatusIcon;